import { useCallback, useEffect, useState } from 'react';

export type UseExternalScriptProps = {
  src: string;
  id: string;
  removeOnUnmount?: boolean;
  defer?: boolean;
  onLoad?: () => void;
};

export const useExternalScript = ({ src, id, removeOnUnmount = true, defer, onLoad }: UseExternalScriptProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const load = useCallback(() => {
    if (isLoaded || document.getElementById(id)) return; // Prevent reloading the same script

    const script = document.createElement('script');
    script.src = src;
    script.id = id;
    script.async = true;

    if (defer) {
      script.defer = true;
    }

    if (onLoad) {
      script.onload = onLoad;
    }

    document.body.appendChild(script);

    setIsLoaded(true);
  }, [defer, id, isLoaded, onLoad, src]);

  useEffect(() => {
    return () => {
      if (isLoaded && removeOnUnmount) {
        const existingScript = document.getElementById(id);
        if (existingScript) {
          existingScript.remove();
        }
      }
    };
  }, [id, isLoaded, removeOnUnmount]);

  return load;
};
